import styled from "styled-components";

export const AdministrarItemVritrinePageStyle = styled.div`
  display: flex;
`;
